import {gsap} from "gsap";

export function animate_words(heading) {
    const timeline = gsap.timeline();
    const $words = $(heading).find('.text-chunk span');

    gsap.killTweensOf($words);

    timeline.set($words, {
        yPercent: 60,
        opacity: 0
    });

    timeline.to($words, {
        opacity: 1,
        ease: 'power2.inOut',
        yPercent: 0,
        stagger: {each: 0.1},
        duration: 0.8,
    });
}

export function split_text(heading) {
    const text = heading.text();
    const words = text.split(' ').filter(Boolean);

    heading.text('');
    heading.css('visibility', 'visible');

    // Keep the real text available to assistive tech, hide the split chunks
    heading.attr('aria-label', text.trim());

    $.each(words, function(_, word) {
        const $chunk = $('<div class="text-chunk" aria-hidden="true"></div>');
        $chunk.append($('<span></span>').text(word + '\u00A0'));
        heading.append($chunk);
    });
}

export function animate_text(text) {
    split_text(text);
    animate_words(text);
}
